import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/styles.scss';

import {
  ConfirmSignIn,
  RequireNewPassword,
  withAuthenticator,
} from 'aws-amplify-react';
import {
  LoopConfirmSignUp,
  LoopForgotPassword,
  LoopSignIn,
  LoopSignUp,
  LoopVerifyContact,
} from './auth';

import AppRouter from './navigation/AppRouter';

/* eslint-disable react/jsx-key */
export default withAuthenticator(AppRouter, false, [
  <LoopSignIn />,
  <ConfirmSignIn />,
  <LoopVerifyContact />,
  <LoopSignUp />,
  <LoopConfirmSignUp />,
  <LoopForgotPassword />,
  <RequireNewPassword />,
]);
